module.exports = __webpack_public_path__ + "img/menubrush.8243cf0f.png";